export var ADD_GROUP = "ADD_GROUP";
export var ADD_CASE_GROUP = "ADD_CASE_GROUP";
export var REMOVE_GROUP = "REMOVE_GROUP";
export var SET_CONJUNCTION = "SET_CONJUNCTION";
export var SET_NOT = "SET_NOT";
export var ADD_RULE = "ADD_RULE";
export var REMOVE_RULE = "REMOVE_RULE";
export var SET_FIELD = "SET_FIELD";
export var SET_FIELD_SRC = "SET_FIELD_SRC";
export var SET_OPERATOR = "SET_OPERATOR";
export var SET_VALUE = "SET_VALUE";
export var SET_VALUE_SRC = "SET_VALUE_SRC";
export var SET_FUNC_VALUE = "SET_FUNC_VALUE";
export var SET_OPERATOR_OPTION = "SET_OPERATOR_OPTION";
export var SET_LOCK = "SET_LOCK";
export var SET_TREE = "SET_TREE";
export var MOVE_ITEM = "MOVE_ITEM";
export var PLACEMENT_AFTER = "after";
export var PLACEMENT_BEFORE = "before";
export var PLACEMENT_APPEND = "append";
export var PLACEMENT_PREPEND = "prepend";
export var SET_DRAG_PROGRESS = "SET_DRAG_PROGRESS";
export var SET_DRAG_START = "SET_DRAG_START";
export var SET_DRAG_END = "SET_DRAG_END";